import React, { memo } from "react";

import { ShowcaseIntro } from "ui/components/Showcase";

import {
  TIRE_SET_DEMOUNT_INTRO_TEXTS,
  TIRE_SET_DEMOUNT_NEW_SET_STEP,
  TIRE_SET_DEMOUNT_SUMMARY_STEP,
  TIRE_SET_DEMOUNT_WAREHOUSE_STEP,
} from "./consts";
import DemountNewSetScene from "./scenes/DemountNewSetScene";
import DemountSummaryScene from "./scenes/DemountSummaryScene";
import DemountWarehouseScene from "./scenes/DemountWarehouseScene";
import { TireSetDemountIntroProps, TireSetDemountSceneProps } from "./types";

/** Scena za korak demontaže seta guma. */
const STEP_SCENES: Record<number, React.FC<TireSetDemountSceneProps>> = {
  [TIRE_SET_DEMOUNT_WAREHOUSE_STEP]: DemountWarehouseScene,
  [TIRE_SET_DEMOUNT_NEW_SET_STEP]: DemountNewSetScene,
  [TIRE_SET_DEMOUNT_SUMMARY_STEP]: DemountSummaryScene,
};

/** Lijevi panel demontaže: set guma putuje s vozila na skladište, a novi set na vozilo. */
const TireSetDemountIntro: React.FC<TireSetDemountIntroProps> = ({ stepCurrent, stepCount, ...sceneProps }) => {
  const stepKey = STEP_SCENES[stepCurrent] ? stepCurrent : TIRE_SET_DEMOUNT_WAREHOUSE_STEP;
  const Scene = STEP_SCENES[stepKey];
  const text = TIRE_SET_DEMOUNT_INTRO_TEXTS[stepKey];
  // Nazivi se razrješavaju tek pri ulasku u potvrdu; nakon povratka i promjene odabira bili bi zastarjeli.
  const props: TireSetDemountSceneProps =
    stepKey === TIRE_SET_DEMOUNT_SUMMARY_STEP
      ? sceneProps
      : { currentSet: sceneProps.currentSet, formValues: sceneProps.formValues };

  return (
    <ShowcaseIntro
      sceneKey={stepKey}
      title={text.title}
      description={text.description}
      stepCurrent={stepKey}
      stepCount={stepCount}
    >
      <Scene {...props} />
    </ShowcaseIntro>
  );
};

export default memo(TireSetDemountIntro);
